import { render, staticRenderFns } from "./NewsPlace.vue?vue&type=template&id=53fd9f96&"
import script from "./NewsPlace.vue?vue&type=script&lang=js&"
export * from "./NewsPlace.vue?vue&type=script&lang=js&"
import style0 from "./NewsPlace.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewsPlace.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports